import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apps/behes.dev/src/components/studio/StudioHome.jsx");
